import { Zap } from 'lucide-react'
import StoreBadgesGrid from '@/components/StoreBadgesGrid'
import { STRINGS } from '@/constants'
import { handoffToApp } from '@/utils/openApp'

const CTX = 'InstantConnectButton'

interface Props {
  token: string
}

const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent)
const isAndroid = /Android/.test(navigator.userAgent)
const isMobile = isIOS || isAndroid

export default function InstantConnectButton({ token }: Props) {
  const handleMobileClick = () =>
    handoffToApp({ deepLink: `connexa://qr/${token}`, isIOS, ctx: CTX })

  if (isMobile) {
    return (
      <button onClick={handleMobileClick} className="btn btn-outline">
        <Zap className="w-4 h-4" />
        {STRINGS.qr.instantConnect}
      </button>
    )
  }

  // Desktop: official store badges — cross-device handoff cannot work from
  // a desktop browser, so we just point at the stores.
  return <StoreBadgesGrid />
}
